import React, { Component, ErrorInfo, PropsWithChildren } from 'react';

import logger from 'logger';
import ErrorHandler from 'components/ErrorHandler/ErrorHandler';
import { translate } from 'services/i18nService';


type State = {
  hasError: boolean;
};

export default class ErrorBoundary extends Component<PropsWithChildren, State> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = { hasError: false };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error({ msg: 'Page rendering failed', error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorHandler errorStatus={translate('strings.strings.error', { 0: 'Page' })} />;
    }

    return this.props.children;
  }
}
